import {
  GET_CHAR_PRODUCT,
  GET_CONTINUING,
  GET_UNIT,
  GET_NEW_DRUG_CLASSIFIC,
  GET_OTC_RISK_CLASSIFIC,
  GET_ACCESS_OTC,
  GET_ACTION_TAKEN_PROD,
  GET_DID_REACTN_ABATE,
  GET_UNIT_MIN,
  GET_UNIT_YR,
  GET_UNIT_HR,
  ADD_PRODUCT_INFO,
  GET_RES_TO_FDA_REQ,
  GET_SPECIFY,
  GET_ACTION_TAKEN,
  GET_REACT_EVOL_AFTER,
} from '../../types'

const INITIAL_STATE = {
  allCharProduct: [],
  allContinuing: [],
  allUnit: [],
  allNewdrugClass: [],
  allOtcRiskClas: [],
  allAccessOtc: [],
  allActionTakenProd: [],
  allDidReactAbate: [],
  allUnitMin: [],
  allUnitYr: [],
  allUnitHr: [],
  allRestoFdaReq: [],
  allSpecify: [],
  allActionTaken: [],
  allReactEvolAftr: [],
  addAllProductInfo: [],
}

const productInfoReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    //main product add
    case ADD_PRODUCT_INFO:
      return {
        ...state,
        addAllProductInfo: payload,
      }

    case GET_CHAR_PRODUCT:
      return {
        ...state,
        allCharProduct: payload,
      }
    case GET_CONTINUING:
      return {
        ...state,
        allContinuing: payload,
      }
    case GET_UNIT:
      return {
        ...state,
        allUnit: payload,
      }
    case GET_NEW_DRUG_CLASSIFIC:
      return {
        ...state,
        allNewdrugClass: payload,
      }
    case GET_OTC_RISK_CLASSIFIC:
      return {
        ...state,
        allOtcRiskClas: payload,
      }
    case GET_ACCESS_OTC:
      return {
        ...state,
        allAccessOtc: payload,
      }
    case GET_ACTION_TAKEN_PROD:
      return {
        ...state,
        allActionTakenProd: payload,
      }
    case GET_DID_REACTN_ABATE:
      return {
        ...state,
        allDidReactAbate: payload,
      }
    case GET_UNIT_MIN:
      return {
        ...state,
        allUnitMin: payload,
      }
    case GET_UNIT_YR:
      return {
        ...state,
        allUnitYr: payload,
      }
    case GET_UNIT_HR:
      return {
        ...state,
        allUnitHr: payload,
      }
    case GET_RES_TO_FDA_REQ:
      return {
        ...state,
        allRestoFdaReq: payload,
      }
    case GET_SPECIFY:
      return {
        ...state,
        allSpecify: payload,
      }
    case GET_ACTION_TAKEN:
      return {
        ...state,
        allActionTaken: payload,
      }
    case GET_REACT_EVOL_AFTER:
      return {
        ...state,
        allReactEvolAftr: payload,
      }

    default:
      return state
  }
}

export default productInfoReducer
